module.exports = __webpack_public_path__ + "img/portfolio-2.24dfcf21.png";